import { createSelector } from 'reselect';
import { IAppState } from 'spw-redux/reducer';

export const selectWorksheetsUsingSpaceType = (state: IAppState) =>
  state.programmingProgramSummaryReducer.worksheetsUsingSpaceType;

export const selectScenarioIdsUsingSpaceType = createSelector(
  selectWorksheetsUsingSpaceType,
  (worksheetsUsingSpaceType) =>
    worksheetsUsingSpaceType?.map((ws) => ws.scenario.id) as number[]
);

export const selectPositionablePSDialogCounter = (state: IAppState) =>
  state.programmingProgramSummaryReducer.positionablePSDialogCounter;
